import Paginator from './offers-paginator';

class OffersRetriever {

    constructor($) {
        this._resultsContainer = document.querySelector('[data-contains="search-results:items"]');

        if(!this._resultsContainer)
        {
            window.fetchSearchResults = function() {};
            return;
        }

        this._$ = $;
        this._awaiterContainer = document.querySelector('#offers .awaiter');

        this._$populatedContainer = $('[data-contains="sears-results:populated"]');
        this._$emptyContainer = $('[data-contains="search-results:empty"]');

        this._$resultsContainer = $(this._resultsContainer);
        this._$animationContainer = $('body, html');

        this._lastPayload = {};

        const self = this;

        $(document).on('offers-search:push-to-payload', (event, payload) => {
            self._mergePayload(payload);
        });

        $(document).on('offers-search:fetch', (event, payload) => {
            self._fetch(payload);
        });

        window.fetchSearchResults = function(payload = {}, animate = false) {
            return self._fetch(payload, animate);
        };
    }

    init() {
        if( ! this._resultsContainer )
        {
            return;
        }
    }

    _fetch(payload = {}, animate = false) {
        if( !('page' in payload) )
        {
            payload.page = window.extractFromHref('page', [1]).shift();
        }

        this._openAwaiter();

        this._$.ajax({
            method: 'post',
            url: this._resultsContainer.getAttribute('data-source'),
            data: this._mergePayload(payload),
            error: () => {
                this._handleAjaxEmptyResponse();
            }
       }).done((responseBody, responseStatus, rawResponse) => {
           this._handleAjaxResponse(responseBody, rawResponse.status);
       }).then(() => { this._animateToTop(animate) });
    }

    _mergePayload(fresh = {})
    {
        this._lastPayload = Object.assign({}, this._lastPayload, fresh);

        for(var key in this._lastPayload)
        {
            if( this._lastPayload[key] === null )
            {
                delete this._lastPayload[key];
            }
        }

        return this._lastPayload;
    }

    _openAwaiter() {
        this._awaiterContainer.classList.add('await');
    }

    _closeAwaiter() {
        this._awaiterContainer.classList.remove('await');
    }

    _handleAjaxResponse(response, status = 204) {
        if(status !== 200 || response.total === 0)
        {
            return this._handleAjaxEmptyResponse();
        }

        this._$(document).trigger('offers-counter:fill', ['total' in response ? response.total : 0]);
        this._$(document).trigger('offers-pagination:fill', ['pagination' in response ? response.pagination : {page: 1, total: 0, per_page: 12}]);

        this._closeAwaiter();

        this._$resultsContainer.empty().html( response.results.join('') );

        this._$populatedContainer.show();
        this._$emptyContainer.hide();
    }

    _handleAjaxEmptyResponse() {
        this._$(document).trigger('offers-counter:fill', [0]);
        this._$(document).trigger('offers-pagination:fill', [{page: 1, total: 0, per_page: 12}]);

        this._closeAwaiter();
        this._$populatedContainer.hide();
        this._$emptyContainer.show();
        return;
    }

    _animateToTop(animate = false) {
        if(animate === true)
        {
            this._$animationContainer.animate({scrollTop: this._$('#offers').offset().top});
        }
    }
}

try {
    (function($) {
        (new OffersRetriever($)).init();
    })(window.jQuery);
} catch(e) { console.log(e); }
